export default __webpack_public_path__ + "static/media/moon-bg-sm.dc4e650c.png";